import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	List,
	ListItem,
	ListItemIcon,
	styled,
	Typography
} from "@mui/material";
import Button from "components/Buttons/ThemeButton";

export const StyledActionButton = styled(Button)({
	paddingTop: ".75rem",
	paddingBottom: ".75rem",
	width: "calc(100% - 3rem)",
	marginBottom: 1,
	marginLeft: 2,
	marginRight: 2
});
export const StyledActionsBox = styled(Box)({
	//paddingTop: ".75rem",
	//paddingBottom: ".75rem",
	//width: "calc(100% - 6rem)",
	//marginBottom: 1,
	//marginLeft: 2,
	//marginRight: 2,
	padding: "0rem",
	display: "flex",
	justifyContent: "center"
});
export const StyledDialogActions = styled(DialogActions)({
	justifyContent: "center",
	flexDirection: "column",
	padding: "0.2rem",
	paddingBottom: "0.6rem"
});

export const StyledDialog = styled(Dialog)<{ scale: number }>`
	.MuiPaper-root {
		transform: scale(${(props) => props.scale});
		border-radius: 18px;
		width: 400px;
		min-width: 400px;
		min-height: 464px;
	}
`;
export const StyledDialogTitle = styled(DialogTitle)({
	height: "68px",
	padding: "5px",
	backgroundColor: "SteelBlue",
	backgroundPosition: "center",
	backgroundSize: "auto 100%",
	overflow: "hidden",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	"& img": {
		height: "200px",
		maxWidth: "100%",
		maxHeight: "100%"
	}
});
export const StyledDialogContent = styled(DialogContent)({
	paddingBottom: 0,
	maxHeight: "calc(100% - 194px)",
	padding: 0
});
export const StyledDialogContentText = styled(DialogContentText)({
	padding: ".5rem 0rem 0rem",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	textAlign: "center"
});

export const StyledList = styled(List)({
	width: "95%",
	//maxWidth: 360,
	padding: "0rem",
	bgcolor: "background.paper",
	"& .MuiListItemText-primary": { fontWeight: "bold", fontSize: "98%" },
	"& .MuiListItem-root": { paddingLeft: 0, paddingRight: 0 },
	"& .MuiListItemText-secondary": { fontSize: "77%" },
	height: "100%",
	overflow: "auto"
});

export const StyledListHeading = styled(Typography)({
	fontWeight: "800",
	margin: ".15rem 0 0.2rem",
	display: "block",
	textAlign: "center",
	lineHeight: 1.334,
	color: "#333333",
	fontSize: "1.4rem"
});

export const StyledListItemIcon = styled(ListItemIcon)({
	display: "flex",
	justifyContent: "flex-start",
	alignItems: "center",
	minWidth: "46px",
	marginTop: ".5rem",
	svg: {
		width: "auto",
		height: "30px"
	}
});

export const StyledListItem = styled(ListItem)({
	alignItems: "flex-start",
	padding: "0rem"
});
